<template>
  <div class="c-cnchorLinkList">
    <div class="c-cnchorLinkList__pans">
      <div
        v-for="(item, index) in items"
        :key="'c-cnchorLinkList-pan' + index"
        class="c-cnchorLinkList__pan"
      >
        <a :href="`#${item.id}`" v-smooth-scroll="vSmoothScrollOption">
          {{ item.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnchorLinkList",
  props: {
    items: {
      type: Array,
      required: true,
    },
    vSmoothScrollOption: {
      type: Object,
      required: false,
      default: () => {
        return {
          duration: 0,
          offset: -20,
        };
      },
    },
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    scrollWindow() {},
  },
};
</script>

<style></style>
